import React, { useState, useEffect, useRef } from 'react';

const SVGIcon = ({ name, size = 16, }) => {
    const ImportedIconRef = useRef(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        const importIcon = async () => {
            try {
                // var xhr = new XMLHttpRequest;
                // xhr.open('get', './' + name + '.svg', true);
                // xhr.onreadystatechange = function () {
                //     console.log(xhr);
                //     if (xhr.readyState != 4) return;
                //     if (xhr.responseXML) {
                //         var svg = xhr.responseXML.documentElement;
                //         ImportedIconRef.current = document.importNode(svg, true); // surprisingly optional in these browsers
                //     }
                // };
                // xhr.send();

                const { default: namedImport } = await import(`../../components/${name}`);
                // const svgImg = (await import(`../${name}.svg`)).ReactComponent;
                ImportedIconRef.current = namedImport;
            } catch (err) {
                throw err;
            } finally {
                setLoading(false);
            }
        };
        importIcon();
    }, [name]);

    if (!loading && ImportedIconRef.current) {
        const { current: ImportedIcon } = ImportedIconRef;
        return <ImportedIcon width={size} height={size} />;
    }

    return null;
};

export default SVGIcon;